import { APIS_BASE_URL } from '../constants/env';

export const getImageUrl = ({ imageKey, imageType, parcelNumber = '' }) =>
  `${APIS_BASE_URL}/images/${imageKey}?imageType=${imageType}&parcelNumber=${parcelNumber}`;
